const priorityColorMap = {
  High: '#e75167',
  Medium: '#ff991f',
  Low: '#00a3bf',
  Highest: '#de350c',
  Lowest: '#028759'
};
const priorityLabels = {
  lowest: 'Lowest',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  highest: 'Highest'
};
const PriorityDonutChart = (data) => {
  const priorityData = Object.entries(data).map(([key, value]) => ({
    name: priorityLabels[key.toLowerCase()] || key,
    value
  }));
  const safeData = Array.isArray(priorityData) ? priorityData : [];

  const totalTasks = safeData.reduce((sum, item) => sum + item.value, 0);

  return {
    title: {
      text: `${totalTasks}`,
      subtext: 'Total Tasks',
      left: '50%',
      top: '35%',
      textAlign: 'center',
      textVerticalAlign: 'middle',
      textStyle: {
        fontSize: 24,
        fontWeight: 'bold'
      },
      subtextStyle: {
        fontSize: 14,
        color: '#888'
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: ({ name, value, percent }) =>
        `${name} Priority<br/>🧮 ${value} Tasks (${percent}%)`
    },
    legend: false,
    series: [
      {
        name: 'Priority Tasks',
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '42%'],
        itemStyle: {
          borderRadius: 6,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: true,
          position: 'outside',
          formatter: '{b}: {c} ({d}%)'
        },
        labelLine: {
          show: true
        },
        data: safeData.map(item => ({
          ...item,
          itemStyle: { color: priorityColorMap[item.name] || '#ccc' }
        }))
      }
    ]
  };
};

export default PriorityDonutChart;